module.exports = __webpack_public_path__ + "img/procurement.ed002d49.png";